import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import ElementIcon from './ElementIcon';
import { themeVars } from '../config/theme';
import { authService } from '../services';
import '../styles/DashboardPage.scss';

const UserIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

const DashboardPage = ({ title, subtitle, actions, backTo = '/', showProfile = false, theme = 'overview' }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [profileOpen, setProfileOpen] = useState(false);

  useEffect(() => {
    authService.getCurrentUser()
      .then(setUser)
      .catch((err) => console.error('Failed to load user:', err));
  }, [navigate]);

  return (
    <div className="dp-container themed" style={themeVars(theme)}>
      <div className="dp-header">
        <button className="dp-back" onClick={() => navigate(backTo)}>← Back</button>
        <ElementIcon element={theme} />
        <div className="dp-title">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>

      <div className="dp-body">
        <div className="dp-section-label">Select an area to manage</div>
        <div className="dp-grid">
          {actions.map((action) => (
            <button
              key={action.label}
              className="dp-card"
              onClick={action.onClick}
            >
              <div className="dp-card-icon">{action.icon}</div>
              <span className="dp-card-label">{action.label}</span>
              <span className="dp-card-desc">{action.desc}</span>
            </button>
          ))}
        </div>
      </div>

      {showProfile && <div className="dp-profile-panel">
        {profileOpen && (
          <div className="dp-profile-drawer">
            <h3>Your Profile</h3>
            {user ? (
              <>
                <div className="dp-profile-row">
                  <strong>Name:</strong>
                  <span>{user.first_name} {user.last_name}</span>
                </div>
                <div className="dp-profile-row">
                  <strong>Email:</strong>
                  <span>{user.email}</span>
                </div>
                <div className="dp-profile-row">
                  <strong>Company:</strong>
                  <span>{user.company_name}</span>
                </div>
                <div className="dp-profile-row">
                  <strong>Role:</strong>
                  <span>{user.designation || '—'}</span>
                </div>
              </>
            ) : (
              <p className="dp-profile-row">Loading...</p>
            )}
            <div className="dp-profile-actions">
              <Button onClick={() => navigate('/profile')}>Edit Profile</Button>
            </div>
          </div>
        )}

        <button
          className="dp-profile-toggle"
          onClick={() => setProfileOpen((prev) => !prev)}
        >
          <UserIcon />
          {profileOpen ? 'Close Profile' : 'View Profile'}
        </button>
      </div>}
    </div>
  );
};

export default DashboardPage;
